import 'css-chunk:src/app/containers/App/LoginView.scss';export default {
  "LoginView": "_LoginView_lwb21_1",
  "card": "_card_lwb21_8",
  "logo": "_logo_lwb21_19",
  "loginButton": "_loginButton_lwb21_28",
  "errorMessage": "_errorMessage_lwb21_31"
};